import { IconProps } from "./Icon.model";

export function Ticket03Icon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.94727 3.25C8.34065 3.24999 7.07175 3.2496 6.06152 3.36231C5.02602 3.47785 4.17517 3.71942 3.44336 4.26172C2.94028 4.63463 2.50467 5.09681 2.15527 5.625C1.5101 6.60041 1.31981 7.78298 1.25195 9.3457C1.21955 10.0921 1.84779 10.5935 2.46484 10.5938C3.39674 10.5938 4.22461 11.4064 4.22461 12.5C4.22461 13.5936 3.39674 14.4062 2.46484 14.4062C1.84779 14.4065 1.21955 14.9079 1.25195 15.6543C1.31981 17.217 1.5101 18.3996 2.15527 19.375C2.50467 19.9032 2.94028 20.3654 3.44336 20.7383C4.17517 21.2806 5.02602 21.5222 6.06152 21.6377C7.07174 21.7504 8.34066 21.75 9.94727 21.75H14.0537L15.1963 21.748C16.2784 21.7428 17.1817 21.7222 17.9395 21.6377C18.975 21.5221 19.8258 21.2806 20.5576 20.7383C21.0607 20.3654 21.4963 19.9032 21.8457 19.375C22.491 18.3994 22.6812 17.2164 22.749 15.6533C22.7495 15.6426 22.75 15.6318 22.75 15.6211L22.75 9.37891C22.75 9.36816 22.7495 9.35742 22.749 9.34668C22.6812 7.78358 22.491 6.60056 21.8457 5.625C21.4963 5.09678 21.0607 4.63465 20.5576 4.26172C19.8258 3.71936 18.975 3.47786 17.9395 3.36231C16.9292 3.24958 15.6604 3.24999 14.0537 3.25L9.94727 3.25ZM17 15.5C17.5523 15.5 18 15.9477 18 16.5C18 17.0523 17.5523 17.5 17 17.5L9 17.5C8.44772 17.5 8 17.0523 8 16.5C8 15.9477 8.44771 15.5 9 15.5L17 15.5ZM17 11.5C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5H13C12.4477 13.5 12 13.0523 12 12.5C12 11.9477 12.4477 11.5 13 11.5H17Z"
        fill={fillColor}
      />
    </svg>
  );
}
